/**
 * OrgChart bundle entry point.
 * Imports config first (sets window globals), then all modules in order.
 * loadorgchart must run before bootstrap (document.ready).
 */
console.log("I am main.js");
import './config.js';

// OrgChart modules - order matters for class availability
import './modules/navigation.js';
import './modules/copy-upload-tables.js';
import './modules/draw-org-charts.js';
import './modules/tokens-toggle.js';
import './modules/left-panel.js';
import './modules/data-fetching.js';
import './modules/filters-search.js';
import './modules/combo-load-data.js';
import './modules/page-contents-modals.js';
import './modules/state-query.js';
import './modules/upload-utils.js';
import './modules/utility-functions.js';
import './modules/misc-handlers.js';
import './modules/components.js';
import './modules/modal-api.js';

// Loadorgchart (GoJS diagram setup) - uses window.go, Robot
import './loadorgchart.js';

// Bootstrap - document.ready
import './modules/bootstrap.js';
